<mat-toolbar
  color="primary"
  class="apearAnimation flex-row flex content-between relative rounded-md"
>
<span class="font-semibold">Configuración</span>
</mat-toolbar>

<div class="margin-container apearAnimation">
  <mat-card

  >
    <mat-card-content class="dashboard-card-content">
      <div>
        <h1>Parametros de ingreso</h1>
      </div>

      <br />

      <form [formGroup]="perfilFormGroup">
        <div
        class="flex flex-wrap"
        >
          <mat-form-field
            appearance="outline"
          >
            <mat-label>Días de periodo de espera</mat-label>
            <input
              matInput
              maxlength="3"
              type="number"
              min="0"
              formControlName="diasPeriodoGracia"
              required
            />
          </mat-form-field>

          <mat-form-field
            appearance="outline"
          >
            <mat-label>Minutos de ingreso previo</mat-label>
            <input
              matInput
              maxlength="3"
              type="number"
              min="0"
              formControlName="minutosIngresosPrevioEntreno"
              required
            />
          </mat-form-field>

          <mat-form-field
            appearance="outline"
          >
            <mat-label>Minutos de reutilización de Qr</mat-label>
            <input
              matInput
              maxlength="2"
              type="number"
              min="0"
              formControlName="tiempoReusoCodigo"
              required
            />
          </mat-form-field>

          <div class="example-full-width">
            <mat-slide-toggle
              class="example-margin"
              formControlName="ingresoSinRestriccionDeHorarios"
            >
              Restricción de horarios
            </mat-slide-toggle>
          </div>

          <div class="example-full-width">
            <mat-slide-toggle
              class="example-margin"
              formControlName="aceptaOrdenAutomatica"
            >
              Aceptar orden de compra automática
            </mat-slide-toggle>
          </div>

          <div class="example-full-width">
            <mat-slide-toggle
              class="example-margin"
              formControlName="permiteDeudaSaldo"
            >
              Permite deuda en saldo de clubes
            </mat-slide-toggle>
          </div>

          <div class="example-full-width">
            <mat-slide-toggle
              class="example-margin"
              formControlName="permiteOrdenSinHorarios"
            >
              Permite enviar orden de compra con usuarios sin horario
            </mat-slide-toggle>
          </div>

          <div class="example-full-width">
            <mat-slide-toggle
              class="example-margin"
              formControlName="permiteOrdenSinFoto"
            >
              Permite enviar orden de compra con usuarios sin foto
            </mat-slide-toggle>
          </div>
        </div>
      </form>

      <br />

      <div fxLayout="row" fxLayoutAlign="center">
        <button
          mat-raised-button
          color="primary"
          [disabled]="perfilFormGroup.invalid"
          (click)="actualizar()"
        >
          Guardar Cambios
        </button>
      </div>
    </mat-card-content>
  </mat-card>
</div>
